import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WaterBalanceEtoService {
  constructor(private $http: SuperHttpClientProvider) {}

  getWeeklyEto<T = any>(
    moduleId: number,
    start: string,
    end: string,
    debug = false
  ): Observable<T> {
    const params: any = { start, end };
    if (debug) {
      params.debug = 1;
    }
    return this.$http.default.get(`/admin/module/${moduleId}/weekly-eto`, {
      params
    });
  }
}
